import React, { Component } from 'react';
import styles from './styles';
import { css } from 'aphrodite';

class Error extends Component {

    render() {
        const { reverse, label } = this.props;
        return (
            <div className={css(styles.error, reverse && styles.reverse)}>
                <p className={css(styles.label)}>{label}</p>
            </div>
        );
    }
}

Error.defaultProps = {
    reverse: false,
}

export default Error;